import { ClassBaseService } from './../../services/class-base.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { RouteDataService } from './../../services/route-data.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-custom-brick-assignment',
  templateUrl: './custom-brick-assignment.component.html',
  styleUrls: ['./custom-brick-assignment.component.scss']
})
export class CustomBrickAssignmentComponent implements OnInit, OnChanges {
  @Input() studentUserId;
  @Input() studentPartnerId;
  @Input() brickData: any = [];
  @Input() selectedCategory: number;
  @Input() disableAll: boolean;
  @Input() onAdd: boolean;
  @Input() category = '0';
  @Input() assignableBrick = '0';
  @Input() temperature = '0';
  @Input() heatMapID: number;
  @Input() heatMapTypeId: number;
  @Output() updateHeatMap = new EventEmitter<any>();
  tempDataList;
  categoryList;
  taskDetail;
  heatMapFlag = false;
  hubFlag = false;
  selectedValue: any;
  brickList = [];
  bricksDataList: any;
  categoryFlag = false;
  tempratureFlag = false;
  assignableBrickFlag = false;
  enableTextArea: boolean;

  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private routeDataService: RouteDataService,
    private _commonDataSharedService: CommonDataSharedService,
    private _classBaseService: ClassBaseService
  ) { }

  ngOnInit() {

    if (this.onAdd) {
      this.brickData = [];
      this.enableTextArea = false;
    } else {
      if (this.brickData) {
        this.enableTextArea = this.brickData.title ? this.brickData.title.toLowerCase().replace(/[^a-zA-Z ]/g, ' ') === 'follow up with coaches' : true;
      }
    }
    this.getCategoryData();
    this.getTempratureData();
  }

  ngOnChanges() {
    // this.category = '0';
    // this.assignableBrick='0';
    this.getBricksData(this.category);
  }

  getCategoryData() {

    this._classBaseService.getStudentProgessCategories()
      .subscribe(
        (tempCategoryList: any) => {
          this.categoryList = tempCategoryList;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching category data');
        }
      );
  }

  onChangeCategoryDropDown(object) {
    this.enableTextArea = false;
    this.selectedValue = object.options[object.selectedIndex].value;
    this.getBricksData(this.selectedValue);
  }

  getTempratureData() {
    this._classBaseService.getBrickTemperatureList()
      .subscribe(
        (tempCategoryList: any) => {
          this.tempDataList = tempCategoryList;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching brick temp category');
        });
  }

  getBricksData(id) {
    this.enableTextArea = false;
    this.heatMapFlag = true;
    this.hubFlag = false;
    this.taskDetail = '';
    const selectedType = {
      categoryClassId: id,
      heatmapTypeId: this.heatMapTypeId,
      studentPartnerId: this.studentPartnerId

    };

    this._commonRequestResponseService.postWithHeader('student/bricks/', selectedType)
      .subscribe(
        (bricksList: any) => {
          if (bricksList.length !== 0) {
            this.bricksDataList = bricksList[0].items;

            if (this.selectedCategory && this.brickData && this.disableAll) {
              this.heatMapFlag = this.brickData.assignToHeatMap;
              this.hubFlag = this.brickData.assignToCoching;
              this.temperature = this.brickData.temperatureClassId;
              this.taskDetail = this.brickData.heatMapDetails.replace(/<br\s*[\/]?>/gi, '\n');
            }
            if (this.assignableBrick !== '0') {
              this.taskDetail = this.brickData.heatMapDetails.replace(/<br\s*[\/]?>/gi, '\n');
            }
            if (this.assignableBrick.length) {
              for (let i = 0; i < this.assignableBrick.length; i++) {
                if (this.assignableBrick[i]) {
                  this.assignableBrick = this.assignableBrick[i];
                }
              }
            }
          } else {
            this.bricksDataList = [];
          }
        },
        (error) => {
          this.bricksDataList = [];
          this.notificationService.show('error', 'Error while fetching bricks assignable');
        });
  }

  saveCustomBrickAssignment(form: NgForm) {
    const inputJson = {
      studentUserId: this.studentUserId,
      categoryClassId: form.value.category,
      temperatureClassId: form.value.temperature,
      brickId: this.assignableBrick.toString(),
      text: form.value.taskDetail,
      assignToHeatMap: form.value.heatMapFlag ? form.value.heatMapFlag : false,
      assignToHub: form.value.hubFlag ? form.value.hubFlag : false,
      heatMapID: this.heatMapID
    };

    if (form.value.category === '0' || form.value.temperature === '0' || this.assignableBrick === '0') {
      this.categoryFlag = form.value.category === '0';
      this.tempratureFlag = form.value.temperature === '0';
      this.assignableBrickFlag = this.assignableBrick === '0';
    } else {
      this._commonRequestResponseService.postWithHeader('student/brick', inputJson)
        .subscribe(
          (saveList: any) => {
            form.reset();
            this.assignableBrick = '0';
            this.category = '0';
            this.temperature = '0';
            this.categoryFlag = false;
            this.assignableBrickFlag = false;
            this.tempratureFlag = false;
            this.enableTextArea = false;
            this.routeDataService.reloadHeatMap.next('call Heatmap');
            this._commonDataSharedService.closeBrickPopUp.next('brick');
            this._commonDataSharedService.heatMapOverviewUpdate.next();
            this.notificationService.show('success', 'Assign brick successfully');

            if (this.updateHeatMap) {
              this.updateHeatMap.emit();
            }
          },
          () => {
            this.notificationService.show('error', 'Error while fetching assign brick');
          });
    }

    this._commonDataSharedService.reloadAutoNotes.next();
  }

  brickChange(brickName) {
    this.enableTextArea = brickName.toLowerCase().replace(/[^a-zA-Z ]/g, ' ') === 'follow up with coaches';
  }
}
